import EditBillingProduct from "./EditBillingProduct";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function EditBillingProductWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <EditBillingProduct />
        </XeroFeatureFlagCheck>
    )
}

export default EditBillingProductWrapper;